module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"other":"Annet","completed":"Fullført"},"en":{"other":"Other","completed":"Completed"}}')
  delete Component.options._Ctor
}
